import AppService from '../shared/App.api';
import { taskFromAPI, taskToAPI } from './Task.model';

const tasksEndpoint = '/admin/tasks';

export default {
  getTasks,
  getTaskById,
  createTask,
  updateTask,
};

async function getTasks() {
  const response = await AppService.get(tasksEndpoint);
  return (response.data || []).map(taskFromAPI);
}

async function getTaskById(taskId) {
  const response = await AppService.get(`${tasksEndpoint}/${taskId}`);
  return taskFromAPI(response.data);
}

async function createTask(task) {
  const response = await AppService.postJson(tasksEndpoint, taskToAPI(task));
  return taskFromAPI(response.data);
}

async function updateTask(taskId, task) {
  const response = await AppService.put(
    `${tasksEndpoint}/${taskId}`,
    taskToAPI(task)
  );
  return taskFromAPI(response.data);
}
